module.exports = __webpack_public_path__ + "b3a7eecacdda3f461ab9e7c81dc4a7ca.svg";